import React from "react";
import { CheckCircle2, ArrowLeft, BarChart3, LayoutDashboard } from "lucide-react";
import { useNavigate } from "react-router-dom";
import AdminLayout from "../admin/AdminDashboardLayout";
import Button from "../../utils/Button";

const GradientBlob = ({ className }: { className?: string }) => (
  <div
    className={`absolute rounded-full blur-3xl opacity-40 ${className}`}
    aria-hidden="true"
  />
);

export default function MessagingPaymentSuccess() {
  const navigate = useNavigate();

  return (
    // <AdminLayout role="PARTNER">
      <div className="relative overflow-hidden min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100">
        <GradientBlob className="w-72 h-72 bg-emerald-300 top-10 -left-10" />
        <GradientBlob className="w-80 h-80 bg-indigo-200 bottom-10 right-10" />

        <div className="relative mx-auto max-w-3xl px-4 py-16">
          <div className="mb-8 flex items-center gap-2 text-sm text-gray-500">
            <button
              onClick={() => navigate(-1)}
              className="inline-flex items-center gap-2 rounded-full bg-white px-3 py-1 shadow-sm ring-1 ring-gray-200 hover:ring-gray-300 transition"
            >
              <ArrowLeft className="w-4 h-4" />
              Back
            </button>
            <span className="text-gray-400">•</span>
            <span>Messaging Billing</span>
          </div>

          <div className="rounded-3xl bg-white shadow-xl ring-1 ring-gray-100 overflow-hidden">
            <div className="bg-gradient-to-r from-emerald-500 to-sky-500 text-white p-8">
              <div className="flex items-center gap-4">
                <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-white/15 backdrop-blur">
                  <CheckCircle2 className="w-8 h-8" />
                </div>
                <div>
                  <p className="text-sm uppercase tracking-[0.15em] text-white/80">
                    Payment Confirmed
                  </p>
                  <h1 className="text-2xl md:text-3xl font-semibold leading-tight">
                    Your messaging payment was successful
                  </h1>
                </div>
              </div>
            </div>

            <div className="p-8 space-y-6">
              <div className="rounded-2xl border border-gray-100 bg-slate-50/70 p-6">
                <div className="flex flex-col gap-2 text-gray-700">
                  <h3 className="text-lg font-semibold text-gray-900">What happens next?</h3>
                  <p className="text-sm leading-relaxed text-gray-600">
                    We’ve recorded your payment. Messaging charges for this billing month are settled.
                    You’ll see the finalized receipt in your usage history shortly.
                  </p>
                  <p className="text-sm leading-relaxed text-gray-600">
                    Keep an eye on <span className="font-semibold text-gray-800">Messaging Usage</span> to monitor
                    ongoing SMS and email costs in real time.
                  </p>
                </div>
              </div>

              <div className="grid gap-4 sm:grid-cols-2">
                <Button
                  variant="primary"
                  size="large"
                  label="Back to dashboard"
                  icon={<LayoutDashboard className="w-4 h-4" />}
                  onClick={() => navigate("/partner/dashboard")}
                  additionalClassname="w-full"
                />
                <Button
                  variant="secondary"
                  size="large"
                  label="View messaging usage"
                  icon={<BarChart3 className="w-4 h-4" />}
                  onClick={() => navigate("/partner/payments")}
                  additionalClassname="w-full"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    // </AdminLayout>
  );
}
